// extracted by mini-css-extract-plugin
module.exports = {"block":"e_f1","lead":"e_g1","faces":"e_h1","face":"e_i1","plus":"e_j1","copy":"e_k1","title":"e_l1","text":"e_m1","button":"e_n1","buttonIcon":"e_o1"};